import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { Spotlight } from '@atlaskit/onboarding';

const initialState = {
  spotlight: 0,
};

class SpotlightSection extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onSpotlightNext = this.onSpotlightNext.bind(this);
    this.onSpotlightPrev = this.onSpotlightPrev.bind(this);
  }

  componentWillMount() {
    const spotlight = document.querySelector('.spotlight');
    const nodes = spotlight ? spotlight.querySelectorAll('a') : [];

    const actions = [{
      onClick: this.props.onSpotlightClose,
      text: 'x',
    }, {
      onClick: this.onSpotlightPrev,
      text: 'Prev',
    }, {
      onClick: this.onSpotlightNext,
      text: 'Skip',
    }];

    this.spotlight = [
      <Spotlight
        actions={[actions[0], actions[2]]}
        actionsBeforeElement="1 / 4"
        dialogPlacement="bottom right"
        heading="Do you need help?"
        key="user-promotion"
        target="user-promotion"
      >
        This is the Help for &quot;Create user&quot;, &quot;Edit user&quot;
        and &quot;Delete user&quot; buttons.
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="2 / 4"
        dialogPlacement="bottom center"
        heading="Create user"
        key="create-user"
        target="create-user"
        targetRadius={2}
      >
        You can create your excel and trend application user name.
      </Spotlight>,
      <Spotlight
        actions={actions}
        actionsBeforeElement="3 / 4"
        dialogPlacement="bottom center"
        heading="Edit user"
        key="edit-user"
        targetNode={nodes[0]}
      >
        You can edit your excel and trend application user name.
      </Spotlight>,
      <Spotlight
        actions={[actions[0], actions[1]]}
        actionsBeforeElement="4 / 4"
        dialogPlacement="bottom center"
        heading="Delete user"
        key="delete-user"
        targetNode={nodes[1]}
      >
        You can delete your excel and trend application user name.
      </Spotlight>,
    ];
  }

  onSpotlightNext() {
    this.setState({ spotlight: this.state.spotlight + 1 });
  }

  onSpotlightPrev() {
    this.setState({ spotlight: this.state.spotlight - 1 });
  }

  render() {
    return this.spotlight[this.state.spotlight];
  }
}

SpotlightSection.propTypes = {
  onSpotlightClose: PropTypes.func.isRequired,
};

export default SpotlightSection;
